import React from "react";
import classNames from "classnames";

const InfoBox = ({
  icon,
  text,
  title,
  variant = "info",
  className,
  onClick,
  link,
}) => {
  return (
    <div
      className={classNames("info__box", `info__box--${variant}`, className)}
      onClick={onClick}
    >
      {icon && (
        <div className="info__box--icon">
          {typeof icon === "string" ? <img src={icon} alt="icon" /> : icon}
        </div>
      )}
      <div className="info__box--content">
        {title && <span className="info__box--title">{title}</span>}
        <div
          className="info__box--text"
          dangerouslySetInnerHTML={{ __html: text }}
        ></div>
        {link && <span className="info__box--link">{link}</span>}
      </div>
    </div>
  );
};

export default InfoBox;
